import React, { useEffect, useState, lazy, Suspense } from "react"
import * as styles from "./Header.module.scss"
import MobileMenu from "./Navigation/MobileMenu"
import { Link } from "gatsby"
import { useSiteQuery } from "../../../hooks/layout/useSiteQuery"
import {
  HeaderProvider,
  useHeaderContext,
} from "../../../hooks/layout/HeaderContext"

const DesktopMenu = lazy(() => import("./Navigation/DesktopMenu"))
import {useIsDesktop} from '../../../hooks/function/useIsDesktop'

const HeaderContent = () => {
  const { headerLogo, headerItems } = useSiteQuery()
  const { isOpen, setIsOpen, handleLinkClick } = useHeaderContext()
  const isDesktop = useIsDesktop();

  const transformHeaderItems = items => {
    return items.map(item => ({
      type: item.type || "default",
      title: item.title,
      subTitle: item.subTitle,
      slug: item.slug || "#",
      svgIcon: item.svgIcon || undefined,
      children: item.headerSections
        ? transformHeaderItems(item.headerSections)
        : [],
    }))
  }

  const menuItems = headerItems ? transformHeaderItems(headerItems) : []

  useEffect(() => {
    const bodyEl = document.body  

    const hasDropdownOpen = document.querySelector('.dropdown-open') // Add this


    if (isOpen) {
      bodyEl.style.overflow = "hidden"
    } else {
      bodyEl.style.overflow = ""
    }
  
    return () => {
      bodyEl.style.overflow = ""
    }
  }, [isOpen])
  

  return (
    <header className={`bg-white ${styles.stickyHeader}`}>
      <div className={`${styles.containerWithoutPadding}`}>
        <div className={styles.logo}>
          <Link to="/">
            <img
              src={headerLogo.file.url}
              height={headerLogo.height}
              width={headerLogo.width}
              alt={headerLogo.title}
              className={styles.headerLogo}
              onClick={handleLinkClick}
            />
          </Link>
        </div>

        {isDesktop ? (
          <Suspense fallback={null}>
            <DesktopMenu menuItems={menuItems} />
          </Suspense>
        ) : (
          <div className="mobile">
            <div className={styles.toggleWrapper}>
              <button
                onClick={() => setIsOpen(!isOpen)}
                className={`${styles.toggleBtn} ${isOpen ? styles.open : ""}`}
                aria-label={isOpen ? "Close menu" : "Open menu"}
              >
                <svg
                  className={styles.toggle}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d={
                      isOpen
                        ? "M6 18L18 6M6 6l12 12"
                        : "M4 6h16M4 12h16M4 18h16"
                    }
                  />
                </svg>
              </button>
            </div>

            {isOpen && (
              <MobileMenu menuItems={menuItems} setIsOpen={setIsOpen} />
            )}
          </div>
        )}
      </div>
    </header>
  )
}

const Header = () => (
  <HeaderProvider>
    <HeaderContent />
  </HeaderProvider>
)

export default Header
